<template>
  <main class="sv-error-page">
    <div class="sv-error-card">
      <img src="../assets/images/error-404.png" alt="Página não encontrada">
      <span class="sv-page-header__eyebrow">Erro 404</span>
      <h1>A página que você procura não existe.</h1>
      <router-link
        to="/"
      >
        <i class="ph ph-arrow-left" aria-hidden="true"></i>
        Voltar para o início
      </router-link>
    </div>
  </main>
</template>

<script>
export default {
  name: "ErrorPage",
};
</script>
